import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const footerSections = [
    {
      title: 'Company',
      links: [
        { name: 'Home', path: '/' },
        { name: 'About Us', path: '/about' },
        { name: 'Contact Us', path: '/contact' },
      ],
    },
    {
      title: 'Start Your Business',
      links: [
        { name: 'Register Your Business', path: '/services/register-business' },
        { name: 'LLC Formation', path: '/services/llc' },
        { name: 'Corporation (C-Corp / S-Corp)', path: '/services/corporation' },
        { name: 'DBA (Doing Business As)', path: '/services/dba' },
        { name: 'Nonprofit', path: '/services/nonprofit' },
        { name: 'Sole Proprietorship', path: '/services/sole-proprietorship' },
      ],
    },
    {
      title: 'Run Your Business',
      links: [
        { name: 'Business Compliance', path: '/services/compliance' },
        { name: 'Annual Report Filing', path: '/services/annual-report' },
        { name: 'Business Licenses', path: '/services/licenses' },
        { name: 'Operating Agreement', path: '/services/operating-agreement' },
        { name: 'Registered Agent', path: '/services/registered-agent' },
        { name: 'Virtual Mail', path: '/services/virtual-mail' },
        { name: 'Business Dissolution', path: '/services/dissolution' },
        { name: 'Business Credit', path: '/services/business-credit' },
      ],
    },
    {
      title: 'Protect Your Business',
      links: [
        { name: 'Trademark Registration', path: '/services/trademark' },
        { name: 'Comprehensive Trademark Search', path: '/services/trademark-search' },
        { name: 'Free Trademark Search', path: '/services/free-trademark' },
        { name: 'Trademark Monitoring', path: '/services/trademark-monitoring' },
        { name: 'Provisional Patent', path: '/services/patent' },
        { name: 'Copyright Registration', path: '/services/copyright' },
      ],
    },
    {
      title: 'Estate Planning',
      links: [
        { name: 'Will', path: '/services/will' },
        { name: 'Trust', path: '/services/trust' },
      ],
    },
    {
      title: 'Family Law',
      links: [
        { name: 'Power of Attorney', path: '/services/power-of-attorney' },
        { name: 'Healthcare Directive', path: '/services/healthcare-directive' },
        { name: 'Divorce', path: '/services/divorce' },
      ],
    },
    {
      title: 'Real Estate',
      links: [
        { name: 'Residential Lease', path: '/services/residential-lease' },
        { name: 'Property Deed Transfer', path: '/services/deed-transfer' },
      ],
    },
    {
      title: 'Attorney Services',
      links: [
        { name: 'Business Attorney Plans', path: '/services/business-attorney' },
        { name: 'Personal Attorney Plans', path: '/services/personal-attorney' },
        { name: 'Trademark Attorney', path: '/services/trademark-attorney' },
        { name: 'Other Legal Matters', path: '/services/other-legal' },
      ],
    },
  ];

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-gray-300 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16">
          {/* Brand Section */}
          <div className="mb-12 pb-12 border-b border-gray-800">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between">
              <div className="mb-6 md:mb-0">
                <img src="/logo-white.png" alt="Legal Flick" className="h-12 w-auto mb-4" />
                <p className="text-gray-400 max-w-md leading-relaxed">
                  Professional legal services you can trust. Empowering businesses and individuals with expert guidance and support.
                </p>
              </div>
              <div className="flex flex-col space-y-4">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500 uppercase tracking-wide">Phone</p>
                    <a href="tel:+18555484511" className="text-white hover:text-blue-400 transition-colors font-medium">
                      +1 (855) 548-4511
                    </a>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500 uppercase tracking-wide">Email</p>
                    <a href="mailto:info@legalflick.com" className="text-white hover:text-blue-400 transition-colors font-medium">
                      info@legalflick.com
                    </a>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500 uppercase tracking-wide">Address</p>
                    <p className="text-white font-medium">337 E Main St, Stockton, CA 95202</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Services Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 lg:gap-12">
            {footerSections.map((section, idx) => (
              <div key={idx} className="space-y-4">
                <h3 className="text-white font-bold text-sm uppercase tracking-wider mb-4 pb-2 border-b border-blue-600/30">
                  {section.title}
                </h3>
                <ul className="space-y-3">
                  {section.links.map((link, linkIdx) => (
                    <li key={linkIdx}>
                      <Link
                        to={link.path}
                        className="text-sm text-gray-400 hover:text-blue-400 hover:translate-x-1 transition-all duration-200 inline-flex items-center group"
                      >
                        <span className="w-1 h-1 bg-gray-600 rounded-full mr-2 group-hover:bg-blue-400 transition-colors"></span>
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
              <p className="text-sm text-gray-500">
                © {new Date().getFullYear()} Legal Flick. All rights reserved.
              </p>
              <div className="flex items-center space-x-4 text-xs text-gray-500">
                <span className="flex items-center">
                  <svg className="w-4 h-4 text-green-500 mr-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  SSL Secure
                </span>
                <span className="flex items-center">
                  <svg className="w-4 h-4 text-blue-500 mr-1" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
                  </svg>
                  Trusted by 500,000+
                </span>
              </div>
            </div>
            <div className="flex flex-wrap justify-center gap-6 text-sm">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <span className="text-gray-700">•</span>
              <Link to="/terms-of-service" className="text-gray-400 hover:text-white transition-colors">
                Terms of Service
              </Link>
              <span className="text-gray-700">•</span>
              <Link to="/legal-disclaimer" className="text-gray-400 hover:text-white transition-colors">
                Legal Disclaimer
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;